import React, { useState } from 'react';
import SeoLoader from "./SeoLoader";
import { useLocation, useHistory } from 'react-router-dom';
import {makeStyles} from "@material-ui/core/styles/index";
import {serverRootUrl} from "./config";
import Carousel from "react-elastic-carousel";
import Flex from "./Flex";
import Circle from "./Circle";
import Typography from "@material-ui/core/Typography/Typography";
import * as ReactGA from "react-ga";
import DefaultHeader from "./Components/Layout/DefaultHeader";
import parse from 'html-react-parser';
import Support from "./Components/Support/Support";

const useStyles = makeStyles((theme) => {
    return {
        wrapper: {
            flex: '0 0 100%',
            display: 'flex',
            alignContent: 'flex-start',
            flexWrap: 'wrap',
            boxSizing: 'border-box',
            maxWidth: 1000,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        h1: {
            fontSize: '1rem',
            fontWeight: 'normal',
            margin:0
        },
        carousel: {
            position: 'relative'
        },
        media: {
            height: 400,
            ['@media (max-width:700px)']: {
                height: 200,
            },
            cursor: 'pointer',
            position: 'relative',
            width: '100%',
        },
        image: {
            width: '100%',
            marginTop: '-10%'
        },
        imageContainer: {
            marginRight: 1
        },
        header: {
            maxHeight: 72,
            width: '100%'
        },
        contentHeader: {
            fontSize: '1.25rem',
            fontWeight: 'normal',
            marginTop: 5,
            marginBottom: 10,
            width: '100%',
            ['@media (max-width:700px)']: {
                marginLeft: 10,
            }
        },
        description: {
            width: '100%',
            whiteSpace: 'pre-line',
            ['@media (max-width:700px)']: {
                marginLeft: 10,
                marginRight: 10,
            },
            '& a': {
                color: '#3849a4',
                textDecoration: 'none',
            },
            '& a:hover': {
                textDecoration: 'underline',
            },
            '& h2': {
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            },
            '& h3': {
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            },
            '& h4': {
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            },
        },
        customContent: {
            ['@media (max-width:700px)']: {
                margin: '0 10px'
            }
        }
    }});

export default function LandingPage(props) {

    const location = useLocation();
    const classes = useStyles();

    const [eParams, setEParams] = useState();
    const [imageIndex, setImageIndex] = React.useState(0);

    const onEParams = data => {
        if (!eParams && data) {
            setEParams(data);
            ReactGA.event({
                category: 'User',
                action: 'landing_page',
                label: window.location.pathname
            });
        }
    };

    const header = eParams && eParams.header ? eParams.header : global.eParams ? global.eParams.header :  'Cars for Sale';
    const contentHeader = eParams && eParams.contentHeader ? eParams.contentHeader : global.eParams ? global.eParams.contentHeader :  null;
    const description = eParams && eParams.description ? eParams.description : global.eParams ? global.eParams.description :  null;
    const images = eParams && eParams.images ? eParams.images : global.eParams ? global.eParams.images :  [];
    let options = eParams && eParams.options ? eParams.options : global.eParams ? global.eParams.options : '';
    options = options ? options : '';

    let carousel;

    const isMobile = props.isMobile;

    const switchImage = (e) => {
        const edgeX = isMobile ? 0 : (window.innerWidth - 900)/2;
        const mouseX = e.clientX - edgeX;
        if (mouseX < 200) {
            prevImage();
        } else {
            nextImage();
        }
    };

    const prevImage = (e) => {
        if (imageIndex <= 0) {
            carousel.goTo(images.length - 1);
            setImageIndex(images.length - 1);
        } else {
            setImageIndex(imageIndex - 1);
            carousel.slidePrev();
        }
    };

    const nextImage = (e) => {
        if (imageIndex >= images.length - 1) {
            carousel.goTo(0);
            setImageIndex(0);
        } else {
            setImageIndex(imageIndex + 1);
            carousel.slideNext();
        }
    };


    return (
        <>
            <div className={classes.wrapper}>
                <DefaultHeader url={window.location.pathname} title={header} isMobile={props.isMobile}/>
                {options.indexOf('no-seo') === -1 ? <SeoLoader url={location.pathname} onEParams={onEParams}/> : null}
                {images.length ?
                    <Carousel className={classes.carousel} showArrows={false} ref={ref => (carousel = ref)}
                              preventDefaultTouchmoveEvent={true}
                              enableAutoPlayenableAutoPlay={true}
                              enableSwipe={false}
                              itemsToShow={2}
                              renderPagination={({ pages, activePage, onClick }) => {
                                  return (
                                      <Flex isGallery={true}>
                                          {pages.map(page => {
                                              const isActivePage = activePage === page
                                              return (
                                                  <Circle
                                                      key={page}
                                                      onClick={switchImage}
                                                      active={isActivePage}
                                                  />
                                              )
                                          })}
                                      </Flex>
                                  )
                              }}>
                        {images.map(im =>
                            <div className={classes.media}>
                                <div className={classes.imageContainer}>
                                    <img className={classes.image} alt={im.description ? im.description : header} title={im.description ? im.description : header} src={serverRootUrl + '/' + im.image} onClick={switchImage}/>
                                </div>
                            </div>
                        )}

                    </Carousel> : null}
                {contentHeader ? <Typography className={classes.contentHeader} variant={'h2'}>{contentHeader}</Typography> : null}

                {description ? <Typography className={classes.description}>{parse(description)}</Typography> : null}


                {props.customContent ?  <div className={classes.customContent}>{props.customContent}</div> : null}

            </div>
        </>
    );
}


